import { CreditBalance } from '../../lib/api';

interface CreditBalanceCardProps {
  balance: CreditBalance | null;
  loading: boolean;
}

export function CreditBalanceCard({ balance, loading }: CreditBalanceCardProps) {
  if (loading) {
    return (
      <div className="bg-card rounded-lg shadow-sm border border-border p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-muted rounded w-24 mb-4"></div>
          <div className="h-10 bg-muted rounded w-32 mb-4"></div>
          <div className="flex gap-8">
            <div className="h-4 bg-muted rounded w-20"></div>
            <div className="h-4 bg-muted rounded w-20"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!balance) {
    return (
      <div className="bg-card rounded-lg shadow-sm border border-border p-6">
        <p className="text-muted-foreground">Unable to load credit balance</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h2 className="text-sm font-medium text-muted-foreground mb-2">Current Balance</h2>
      <div className="text-4xl font-bold text-foreground mb-4">
        ${balance.balance.toFixed(2)}
      </div>
      <div className="flex gap-8 text-sm text-muted-foreground">
        <div>
          <span className="font-medium">Lifetime Used:</span>{' '}
          <span className="text-foreground">${balance.lifetimeUsed.toFixed(2)}</span>
        </div>
        <div>
          <span className="font-medium">Lifetime Granted:</span>{' '}
          <span className="text-foreground">${balance.lifetimeGranted.toFixed(2)}</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground/70 mt-4">
        Last updated: {new Date(balance.lastUpdated).toLocaleString()}
      </p>
    </div>
  );
}
